import { useEffect, useState } from 'react';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useDataRequestsApiContext } from '@vivli/core/infrastructure/context';

export function useDataRequestSimple(dataRequestId: string) {
    const dataRequestService = useDataRequestsApiContext();
    const [dataRequest, setDataRequest] = useState<IDataRequest>(null);

    const handleDataRequest = (dataRequest: IDataRequest) => {
        setDataRequest(dataRequest);
    };

    useEffect(() => {
        if (!dataRequestId) {
            return;
        }

        const sub = dataRequestService.getDataRequest(dataRequestId).pipe(first()).subscribe(setDataRequest);

        return () => {
            sub.unsubscribe();
        };
    }, [dataRequestId]);

    return {
        dataRequest,
        setDataRequest,
        handleDataRequest,
    };
}
